import { useState, useEffect, useCallback } from 'react';
import Layout from '@/components/Layout/Layout';
import BackButton from '@/components/ui/BackButton';
import DetailCard, { ICardDetail } from '@/components/common/DetailCard';
import { useParams } from 'react-router-dom';
import {
  IAttendanceRegularizatioDetailResponse,
  IAttendanceRegularization,
} from '@/interfaces/regularization.model';
import ViewDocumentModal from '@/components/common/ViewDocumentModal';
import Logs from '@/components/common/Logs';
import {
  handleAttendanceStatus,
  handleStatus,
} from '../../../utility/CommonFunctions';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { capitalizeFirstLetter, showToastNotification } from '@/utility/helper';
import { IDeleteResponse } from '@/interfaces/common.model';
import moment from 'moment';
import Button from '@/components/ui/Button';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import FullPageLoader from '@/components/loader/FullPageLoader';
import ApproveModal from '@/components/Modal/ApproveModal';
// import ConfirmModal from '@/components/Modal/ConfirmModal';
interface ISubmitData {
  status: number | undefined;
  type: string;
  id: string | undefined;
  reason?: string;
}
const ArRequestDetails = () => {
  const { id } = useParams();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);
  const [actionType, setActionType] = useState<'approve' | 'reject' | null>(
    null,
  );
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const [arDetail, setArDetail] = useState<IAttendanceRegularization | null>(
    null,
  );
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  // const [selectedDocument, setSelectedDocument] = useState(null);
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response: IAttendanceRegularizatioDetailResponse = await callApi(
        `${API_URL + API_ENDPOINT.getArDetail}?attendanceId=${id}`,
        { method: 'GET' },
      );
      if (response?.status) {
        setArDetail(response?.data);
      }
    } catch (err) {
      console.error('Error fetching AR request details:', err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, fetchData]);
  const cardDetails: ICardDetail[] = [
    {
      label: 'Employee Name',
      value: capitalizeFirstLetter(arDetail?.user?.name ?? '-'),
    },
    { label: '   Emp. Code', value: arDetail?.user?.employeeCode ?? '-' },
    {
      label: 'Emp. Dept. ',
      value: arDetail?.user?.department?.name ?? '-',
    },
    {
      label: 'Emp. Designation ',
      value: arDetail?.user?.designation?.name ?? '-',
    },
    {
      label: 'Start Date',
      value:
        (arDetail?.checkInTime &&
          moment(arDetail?.checkInTime).format('DD/MM/YYYY')) ||
        '--',
    },
    {
      label: 'End Date',
      value:
        (arDetail?.checkOutTime &&
          moment.parseZone(arDetail?.checkOutTime).format('DD/MM/YYYY')) ||
        '--',
    },
    {
      label: 'Check-In Time',
      value:
        (arDetail?.checkInTime &&
          arDetail?.checkInTime &&
          moment.utc(arDetail?.checkInTime).format('hh:mm A')) ||
        '--',
    },
    {
      label: 'Check-Out Time',
      value:
        (arDetail?.checkOutTime &&
          arDetail?.checkOutTime &&
          moment.utc(arDetail?.checkOutTime).format('hh:mm A')) ||
        '--',
    },
    { label: 'Reason', value: arDetail?.Arrequests[0]?.reason ?? '-' },
    {
      label: 'Created At',
      value:
        (arDetail?.createdAt &&
          moment(arDetail?.createdAt).format('DD/MM/YYYY')) ||
        '--',
    },
    {
      label: 'Attendance',
      value:
        arDetail?.status !== undefined
          ? handleAttendanceStatus(arDetail.status)
          : '-',
    },
    {
      label: 'Status',
      value: handleStatus(arDetail?.arRequestStatus ?? 0) ?? '-',
    },
    {
      label: 'Applied On',
      value:
        (arDetail?.createdAt &&
          moment(arDetail?.createdAt).format('DD/MM/YYYY')) ||
        '--',
    },
    // arDetail?.approvedBy ? { label: 'Approved By', value: arDetail?.ap } : null,
    // data?.approvedAt
    //   ? {
    //       label: 'Approved At',
    //       value: format(new Date(data.approvedAt), 'dd-MM-yyyy hh:mm a'),
    //     }
    //   : null,
  ].filter(Boolean) as ICardDetail[];
  // const renderDocument = () => {
  //   if (!selectedDocument) return null;

  //   const fileExtension = selectedDocument?.document
  //     ?.split('.')
  //     ?.pop()
  //     ?.toLowerCase();
  //   // const fileExtension = 'docx';

  //   switch (fileExtension) {
  //     case 'jpg':
  //     case 'jpeg':
  //     case 'png':
  //     case 'gif':
  //       return (
  //         <img
  //           src={selectedDocument?.document}
  //           alt="Document Preview"
  //           style={{ maxWidth: '100%', maxHeight: '500px' }}
  //         />
  //       );
  //     case 'pdf':
  //       return (
  //         <iframe
  //           src={selectedDocument?.document}
  //           width="100%"
  //           height="500px"
  //           title="Document Preview"
  //         ></iframe>
  //       );
  //     case 'txt':
  //       return (
  //         <textarea
  //           readOnly
  //           value={selectedDocument?.content} // Assuming `content` is the file content
  //           style={{ width: '100%', height: '500px' }}
  //         />
  //       );
  //     case 'docx':
  //       return (
  //         <div>
  //           <p>DOCX preview not supported in browser directly.</p>
  //         </div>
  //       );
  //     default:
  //       return <p>Unsupported file type</p>;
  //   }
  // };
  const handleApproveReject = async (type: string, reason?: string) => {
    setIsUpdating(true);
    let newStatus;
    if (type == 'approve') {
      newStatus = 1;
    } else if (type == 'reject') {
      newStatus = 2;
    }
    let submitData: ISubmitData = {
      type: 'arRequest',
      id: arDetail?.id,
      status: newStatus,
    };
    if (reason) {
      submitData = {
        type: 'arRequest',
        id: arDetail?.id,
        status: newStatus,
        reason: reason,
      };
    }
    try {
      const response: IDeleteResponse = await callApi(
        API_URL + API_ENDPOINT.userStatusUpdate,
        {
          method: 'POST',
          data: submitData,
        },
      );
      if (response?.status) {
        setIsConfirmModalOpen(false);
        showToastNotification('success', response?.message);
        fetchData();
        setRefreshLogs(true);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsUpdating(false);
    }
  };
  const submitConfirm = (actionType?: string, reason?: string) => {
    if (actionType === 'approve') {
      handleApproveReject('approve');
    } else if (actionType === 'reject') {
      handleApproveReject('reject', reason);
    }
  };

  return (
    <>
      <Layout>
        {loading ? (
          <FullPageLoader />
        ) : (
          <>
            <div className="content container-fluid">
              <BackButton isDetail={true} label="AR Request Details" />
              <DetailCard cardDetails={cardDetails} />
              {arDetail?.arRequestStatus == 0 &&
                arDetail?.userId != userDetails?.id && (
                  <div className="card-body d-flex justify-content-end">
                    <div className="col-12 col-md-6 col-lg-4 ">
                      <span className="d-flex align-items-center gap-3 justify-content-end">
                        <>
                          {/* <Button
                            className="btn btn-success "
                            onClick={() => handleApproveReject('approve')}
                          // disabled={arDetail?.arRequestStatus == 1}
                          >
                            Approve
                          </Button>
                          <Button
                            className="btn btn-danger px-4"
                            onClick={() => handleApproveReject('reject')}
                          // disabled={arDetail?.arRequestStatus == 2}
                          >
                            Reject
                          </Button> */}
                          <Button
                            className="btn btn-success "
                            onClick={() => {
                              setActionType('approve');
                              setIsConfirmModalOpen(true);
                            }}
                          >
                            Approve
                          </Button>

                          <Button
                            className="btn btn-danger px-4"
                            onClick={() => {
                              setActionType('reject');
                              setIsConfirmModalOpen(true);
                            }}
                          >
                            Reject
                          </Button>
                        </>
                      </span>
                    </div>
                  </div>
                )}
              {/* <div className="row">
                <div className="row mt-4">
                  <DetailCard
                    title="Documents"
                    documents={arDetail?.}
                  ></DetailCard>
                </div>
              </div> */}
            </div>
            <Logs
              type={'arRequest'}
              id={id ?? ''}
              refreshLogs={refreshLogs}
              setRefreshLogs={setRefreshLogs}
            />
          </>
        )}
      </Layout>
      <ViewDocumentModal
        isOpen={isOpen}
        toggle={toggleModal}
        // renderDocument={renderDocument}
      />
      {/* <ConfirmModal
        isOpen={isConfirmModalOpen}
        toggle={() => setIsConfirmModalOpen(false)}
        submitHandler={submitConfirm}
        isLoading={false}
        confirmReason={actionType === "reject" ? "reject" : undefined}
        isApprove={true}
      /> */}
      <ApproveModal
        isOpen={isConfirmModalOpen}
        isLoading={isUpdating}
        submitHandler={submitConfirm}
        toggle={() => setIsConfirmModalOpen(false)}
        actionType={actionType ?? ''}
      />
    </>
  );
};

export default ArRequestDetails;
